import store from '@/store'
import remoteConfig from '@/lib/remote-config'


export default (to, from, next) => {
  if(!store.state.user.userLogged) {
      if (!remoteConfig.getBoolean('anonymous_restriction')) {
        next()
        return true
      } else {
        next({ name: 'login', query: { redirect: to.path }})
        return false
      }
  } else {
    next()
  }
}